import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { LoggingService } from 'src/app/services/consoleLogs';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrl: 'nav-item.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('expanded <=> collapsed', animate('300ms ease'))
    ])
  ]
})
export class AppNavItemComponent implements OnChanges, OnInit {
  @Input() item: NavItem | any;
  @Input() depth: any;
  @Input() groupedNavItems: { [key: string]: NavItem[] } = {};
  @Input() activeRoute?: string;
  private static lastExpandedItem: NavItem | null = null;

  @Input() isExpanded: boolean = false;
  @Output() navCapClicked = new EventEmitter<string>();

  constructor(public navService: NavService, public router: Router,private loggingService: LoggingService ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.checkActiveRoute();
    this.initializeNavItems();
    if (this.isItemActive(this.item)) {
      this.loggingService.log(`Active tab on load: ${this.item.displayName || this.item.navCap}`);
    }
  }

  ngOnChanges() {
    this.checkActiveRoute();
    this.initializeNavItems();
  }

  // Enhanced isActive method that considers both route and relatedRoutes
  isItemActive(item: NavItem): boolean {
    if (!item) return false;

    const currentUrl = this.router.url.split('?')[0]; // ignore query params

    // Check if the main route is active
    if (item.route) {
      const baseMatch = this.router.isActive(item.route, {
        paths: 'subset',
        queryParams: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored'
      });
      if (baseMatch) return true;
    }

    // Check relatedRoutes if defined
    if (item.relatedRoutes) {
      const relatedMatch = item.relatedRoutes.some((relatedRoute: string) => {
        const baseRelatedRoute = relatedRoute.split('?')[0];
        return currentUrl.startsWith(baseRelatedRoute);
      });
      if (relatedMatch) return true;
    }

    return false;
  }

  checkActiveRoute() {
    if (this.item.children) {
      const hasActiveChild = this.item.children.some((child: NavItem) =>
        this.isItemActive(child)
      );

      if (hasActiveChild || this.isItemActive(this.item)) {
        this.item.expanded = true;
        AppNavItemComponent.lastExpandedItem = this.item;
      }
    } else if (this.isItemActive(this.item)) {
      // Handle leaf nodes that are active
    }
  }

  private initializeNavItems() {
    if (this.item.navCap && this.item.children) {
      const shouldExpand = this.item.children.some((child: NavItem) =>
        this.isItemActive(child)
      );

      this.item.expanded = shouldExpand;
      if (shouldExpand) {
        AppNavItemComponent.lastExpandedItem = this.item;
      }
    }
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }

    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
  }

  onNavCapClick(item: NavItem) {
    if (item.navCap) {
      if (item.expanded) {
        item.expanded = false;
        AppNavItemComponent.lastExpandedItem = null;
      } else {
        if (AppNavItemComponent.lastExpandedItem) {
          AppNavItemComponent.lastExpandedItem.expanded = false;
        }
        item.expanded = true;
        AppNavItemComponent.lastExpandedItem = item;
      }
    }
  }
}